import style from './list-cirfa.scss';
import inView from 'in-view';
import $ from 'jquery';

const script = () => {

  // Get item list
  const cssClass: string = 'ListCirfa';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);
  const geolocation = window.navigator.geolocation;
  const radians = (degrees:number) => degrees*Math.PI/180;

  function getDistanceFromLatLonInKm(lat1:number,lon1:number,lat2:number,lon2:number) {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2-lat1);  // deg2rad below
    const dLon = deg2rad(lon2-lon1);
    const a =
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon/2) * Math.sin(dLon/2)
    ;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    const d = R * c; // Distance in km
    return d;
  }

  function deg2rad(deg:number) {
    return deg * (Math.PI/180)
  }

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      continue; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    // Add text above list
    const list = elt.querySelector(`.${cssClass}-list`);
    if (list && !$(elt).parents('.LayerOpeningHours')) {
      const text = 'Points de contact à proximité';
      const message = document.createElement('div');
      message.classList.add(`${cssClass}-title`);
      message.textContent = typeof Drupal !== 'undefined' ? Drupal.t(text) : text;
      elt.insertBefore(message, elt.firstChild);
    }

    // Drupal view : move "Point de contact à proximité" to List Before
    const headingTitle = elt.querySelector(`.${cssClass}-heading`);
    if (headingTitle) {
      list.before(headingTitle);
    }

    // For animation on scroll
    const items = elt.querySelectorAll(`.${cssClass}-item`);
    for (const item of items) {
      item.classList.add('isJsAnimated');
    }

    // Init inView for displaying on scroll
    inView(`.${cssClass}-item`)
        .on('enter', (item:HTMLElement)=>{
          item.classList.add('isInViewport');
        });

    // get position from local storage
    let userPosition:any = sessionStorage.getItem('userPosition');
    let formPositionSubmitted:any = sessionStorage.getItem('formPositionSubmitted');
    const querySearch = window.location.search;
    if(querySearch !== '') { // get data from query
      const urlParams = new URLSearchParams(querySearch);
      if(urlParams.get('geoloc_lng') !== '') {
        userPosition = {
          latitude: urlParams.get('geoloc_lat'),
          longitude: urlParams.get('geoloc_lng'),
        }
        formPositionSubmitted = urlParams.get('search_address');
      }
    }
    if(formPositionSubmitted === null) { // we do not come from submitted form
      // we reset sessionStorage userPosition
      userPosition = null;
      sessionStorage.removeItem('userPosition');
    } else { // we come from submitted form
      // we clear submitted value and waiting for the next submit
      setTimeout(()=>{
        sessionStorage.removeItem('formPositionSubmitted');
      }, 500);
    }

    if (userPosition !== null) {
      if(querySearch === '') {
        userPosition = JSON.parse(userPosition);
      }

      // Get location of item in list
      const cssClassLocation: string = 'ListAccess--address';
      const cssClassTeaser: string = 'TeaserSecondary';
      const targetLocation: string = `.${cssClassTeaser} .${cssClassLocation}`;
      const targetsLocations: any = elt.querySelectorAll(targetLocation);

      // Define max distance to define if place is too far
      const farDistance = 150;

      // Get location datas of item
      for (const location of targetsLocations) {
        const latitude: number = parseFloat(location.getAttribute('data-lat'));
        const longitude: number = parseFloat(location.getAttribute('data-lng'));


        if (latitude !== null && longitude !== null) {
          const distance = Math.round(getDistanceFromLatLonInKm(latitude, longitude, userPosition.latitude, userPosition.longitude));

          // Create Item Location element for indicating distance in km
          const teaserParent = location.closest(`.${cssClassTeaser}`);
          let itemLocation = teaserParent.querySelector('.ItemLocation');
          if (itemLocation === null ) { // secure if element is existing
            itemLocation = document.createElement('div');
            itemLocation.classList.add('ItemLocation');
            teaserParent.insertBefore(itemLocation, teaserParent.firstChild);
          }
          if(!isNaN(distance)) {
            itemLocation.innerHTML = `<span>${distance} km</span>`;
            teaserParent.classList.add('isLocated');
          }

          // Add class if cirfa is too far (> 150km)
          if (distance > farDistance) {
            teaserParent.classList.add(`${cssClassTeaser}--far`);
          }
        }
      }
    }
  }
};

export {
  style,
  script,
};
